<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    />
     
  </div>
</template>
<script>
export default {
  props: {
    disabled: Boolean,
    custStatementCode: {
      type: String,
      default: () => '',
    },
   
  },
  data() {
    return {
      backDialogVisible: false,
      formData: { custStatementCode: '', contactStatus: 'Y' },
      
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.contactCode) return
      this.$api
        .finCustomerStatementDetailApi({
          custStatementCode: this.custStatementCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  
  },
}
</script>
